import { createSlice } from "@reduxjs/toolkit";
import { sendEmployeeEmail, getEmailLogs } from "./thunk";

const initialState = {
    emailLogs: [],
    loading: false,
    error: null,
    sendingEmail: false,
    emailError: null
};

const emailSlice = createSlice({
    name: "email",
    initialState,
    reducers: {
        clearEmailError: (state) => {
            state.emailError = null;
        },
        clearEmailLogs: (state) => {
            state.emailLogs = [];
        }
    },
    extraReducers: (builder) => {
        // Send Employee Email
        builder.addCase(sendEmployeeEmail.pending, (state) => {
            state.sendingEmail = true;
            state.emailError = null;
        });
        builder.addCase(sendEmployeeEmail.fulfilled, (state) => {
            state.sendingEmail = false;
            state.emailError = null;
        });
        builder.addCase(sendEmployeeEmail.rejected, (state, action) => {
            state.sendingEmail = false;
        });

        // Get Email Logs
        builder.addCase(getEmailLogs.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getEmailLogs.fulfilled, (state, action) => {
            state.loading = false;
            state.emailLogs = action.payload || [];
            state.error = null;
        });
        builder.addCase(getEmailLogs.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const { clearEmailError, clearEmailLogs } = emailSlice.actions;
export default emailSlice.reducer;
